import { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import GallerySection from "../components/GallerySection";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import FooterThree from "../components/FooterThree";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useLocation } from "react-router-dom";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const GalleryPage = () => {
  const location = useLocation();

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();
  const { setLoading } = useLoader();
  const { allData, setAllData } = useAllDataContext();
  // const [galleryHeaderData, setGalleryHeaderData] = useState([]);
  // const [galleryImagesData, setGalleryImagesData] = useState([]);
  const galleryHeaderData = allData.galleryHeaderData;
  const galleryImagesData = allData.galleryImagesData;
  const galleryBannerData = allData.allBannerData[0]?.gallery_title;

  // useEffect(() => {
  //   setLoading(true);
  //   Promise.all([fetchgalleryHeader(),fetchgalleryImages()])
  //     .then(([galleryHeader, galleryImage]) => {
  //       setGalleryHeaderData(galleryHeader);
  //       setGalleryImagesData(galleryImage);
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     })
  //     .catch(() => {
  //       console.error("Server Error");
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     });
  // }, [setLoading]);
  FetchAllApi({ companyDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb heading={galleryBannerData} title={"Gallery"} />

      {/* GallerySection */}
      <GallerySection
        galleryHeaderData={galleryHeaderData}
        galleryImagesData={galleryImagesData}
      />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default GalleryPage;
